import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const AboutSection = ({ data }) => {
  const { language } = useLanguage();
  
  return (
    <section id="about" className="py-24 bg-brand-soft">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center max-w-7xl mx-auto">
          {/* Image */}
          <div className="order-2 lg:order-1">
            <div className="relative">
              <div className="aspect-[4/5] overflow-hidden shadow-2xl">
                <img 
                  src={data?.image || "https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=1200&q=80"} 
                  alt="Portugal luxury real estate" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-8 -right-8 w-64 h-64 bg-brand-accent rounded-full opacity-30 blur-3xl"></div>
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <div className="mb-8">
              <span className="text-6xl md:text-7xl font-display text-brand-accent-hover opacity-60">{data?.highlight || "Trust"}</span>
            </div>

            <h2 className="text-4xl md:text-5xl font-display font-light text-brand-text mb-8">{data?.title || "Sobre Nós"}</h2>
            
            <div className="space-y-6 text-brand-text-secondary font-body text-lg leading-relaxed">
              <p>{data?.description || "Especialistas em imobiliário de luxo em Portugal"}</p>
            </div>

            {/* Botão Saiba Mais */}
            <div className="mt-8">
              <Link 
                to="/sobre"
                className="inline-flex items-center gap-2 text-brand-primary hover:text-brand-primary-hover font-body font-medium text-lg transition-colors group"
              >
                {language === 'en' ? 'Learn More About Us' : 'Conheça a Nossa História'}
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;